import filter from 'lodash/filter'

export function RemoveBadSprayPoints(data) {
    return filter(data, (d) => d.hc_x_ft && d.hc_y_ft)
}

export function RemoveBadPitchPoints(data) {
    return filter(
        data,
        (d) =>
            d.px &&
            d.pz &&
            d.pitch_type &&
            d.pitch_type !== null &&
            d.pitch_type !== ''
    )
}
